import * as React from 'react';
import styled from 'styled-components';
import MuiOutlinedInput, { OutlinedInputProps as MuiOutlinedInputProps } from '@material-ui/core/OutlinedInput';

const StyledInput = styled(MuiOutlinedInput)``;

export type DSOutlinedInputProps = MuiOutlinedInputProps;
export const DSOutlinedInput: React.FC<DSOutlinedInputProps> = props => <StyledInput {...props} />;
DSOutlinedInput.displayName = 'DSOutlinedInput';
